import { render, staticRenderFns } from "./PerCode.vue?vue&type=template&id=5afd7408&scoped=true&"
import script from "./PerCode.vue?vue&type=script&lang=ts&"
export * from "./PerCode.vue?vue&type=script&lang=ts&"
import style0 from "./PerCode.vue?vue&type=style&index=0&id=5afd7408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd7408",
  null
  
)

export default component.exports